import { rem } from 'polished';
import styled from 'styled-components';

export const FooterClickableElement = styled.a`
  display: inline-block;
  height: 100%;
  padding: ${rem(8)} ${rem(10)};
  line-height: 1.5;
  text-align: left;
  border: ${rem(1)} solid ${({ theme }) => theme.colors.accent};
  color: ${({ theme }) => theme.colors.accent};
  outline: none;
`;

export const FooterDisabledElement = styled.div`
  padding: ${rem(8)} ${rem(10)};
  border: ${rem(1)} solid ${({ theme }) => theme.colors.accent};
  color: ${({ theme }) => theme.colors.accent};
  cursor: not-allowed;
  opacity: 0.5;
`;
